import { LoanActionTargetType, DEFAULT_LOAN_ACTION_VARIANT } from 'constants/loanActions';

export const TaskActionCompletionStatus = {
  NONE: 'None',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
};

export const taskActionCompletionOptions = [
  { name: 'Leave task as is', value: TaskActionCompletionStatus.NONE },
  { name: 'Submit task', value: TaskActionCompletionStatus.SUBMITTED },
  { name: 'Approve task', value: TaskActionCompletionStatus.APPROVED },
];

export const TASK_ACTION_BUTTON_LABEL_MAX_LENGTH = 200;

export const EMPTY_TASK_TYPE_ACTION_FORM = {
  buttonLabel: '',
  icon: '',
  color: '',
  variant: DEFAULT_LOAN_ACTION_VARIANT,
  onSuccessTaskStatus: TaskActionCompletionStatus.NONE,
  targetType: LoanActionTargetType.APPLICATION,
  actions: [],
};

export const TASK_ACTION_UNAVAILABLE_FOR_STATUS_MESSAGE =
  "This task can't be completed from its current status";

export const TASK_ACTION_COMPLETION_NOT_ALLOWED_MESSAGE =
  "You don't have permission to submit or approve this task";

export const TASK_ACTION_NOT_AUTO_COMPLETABLE_MESSAGE =
  "This task can't be completed automatically";

export const TASK_ACTION_UNAVAILABLE_FOR_LOAN_MESSAGE =
  'This action is currently unavailable for this loan';

export const TASK_ACTION_LOAN_DETAILS_FAILED_MESSAGE = "The loan details couldn't be loaded";

export const TASK_ACTION_TITLE = 'Task action';

export const TASK_ACTION_REMOVAL_NOT_ALLOWED_MESSAGE =
  'Saving would remove the task action of this task type, which needs Loan Actions edit permission. Keep the SLA Groups assignee.';

export const TASK_COMPLETION_SKIPPED_RESULT_TYPE = 'TaskCompletionSkipped';

export const TaskActionOriginType = {
  TASK: 'Task',
};
